
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/doors/[slug]",
      function () {
        return require("private-next-pages/pvc/doors/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/doors/[slug]"])
      });
    }
  